__turbopack_context__.v({
  "ctaGroup": "ReviewPanel-module-scss-module__890usq__ctaGroup",
  "ctaLink": "ReviewPanel-module-scss-module__890usq__ctaLink",
  "ctaUnderline": "ReviewPanel-module-scss-module__890usq__ctaUnderline",
  "desktopQuotePanel": "ReviewPanel-module-scss-module__890usq__desktopQuotePanel",
  "eyebrow": "ReviewPanel-module-scss-module__890usq__eyebrow",
  "heading": "ReviewPanel-module-scss-module__890usq__heading",
  "headingPanel": "ReviewPanel-module-scss-module__890usq__headingPanel",
  "mecPeakAvatar": "ReviewPanel-module-scss-module__890usq__mecPeakAvatar",
  "mecPeakIcon": "ReviewPanel-module-scss-module__890usq__mecPeakIcon",
  "mobileFooter": "ReviewPanel-module-scss-module__890usq__mobileFooter",
  "mobileFooterCtas": "ReviewPanel-module-scss-module__890usq__mobileFooterCtas",
  "mobileQuoteAnchor": "ReviewPanel-module-scss-module__890usq__mobileQuoteAnchor",
  "mobileQuoteCard": "ReviewPanel-module-scss-module__890usq__mobileQuoteCard",
  "mobileQuoteTrigger": "ReviewPanel-module-scss-module__890usq__mobileQuoteTrigger",
  "mobileQuoteTriggerLabel": "ReviewPanel-module-scss-module__890usq__mobileQuoteTriggerLabel",
  "mobileQuoteTriggerPeeking": "ReviewPanel-module-scss-module__890usq__mobileQuoteTriggerPeeking",
  "quote": "ReviewPanel-module-scss-module__890usq__quote",
  "quoteAttribution": "ReviewPanel-module-scss-module__890usq__quoteAttribution",
  "quotePanelRoot": "ReviewPanel-module-scss-module__890usq__quotePanelRoot",
  "quoteRow": "ReviewPanel-module-scss-module__890usq__quoteRow",
  "reviewText": "ReviewPanel-module-scss-module__890usq__reviewText",
});
